import { useEffect, useRef, useState } from 'react';

export function useTimer(
  initialSeconds: number,
  isActive = true,
  onExpire: (() => void) | null = null,
) {
  const [seconds, setSeconds] = useState(initialSeconds);
  const onExpireRef = useRef(onExpire);

  useEffect(() => {
    onExpireRef.current = onExpire;
  }, [onExpire]);

  useEffect(() => {
    setSeconds(initialSeconds);
  }, [initialSeconds]);

  useEffect(() => {
    let interval: ReturnType<typeof setInterval> | null = null;

    if (isActive && seconds > 0) {
      interval = setInterval(() => {
        setSeconds((prev) => prev - 1);
      }, 1000);
    } else if (seconds === 0) {
      onExpireRef.current?.();
    }

    return () => {
      if (interval) clearInterval(interval);
    };
  }, [isActive, seconds]);

  const reset = (newSeconds?: number) => {
    setSeconds(newSeconds !== undefined ? newSeconds : initialSeconds);
  };

  return { seconds, reset, setSeconds };
}
